import {
  Component,
  inject,
  signal,
  ChangeDetectionStrategy,
} from "@angular/core";
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterLink,
} from "@angular/router";
import { TranslocoPipe } from "@jsverse/transloco";
import { filter } from "rxjs/operators";

export interface BreadcrumbItem {
  label: string;
  url: string;
}

@Component({
  selector: "app-breadcrumb",
  imports: [RouterLink, TranslocoPipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "./breadcrumb.html",
})
export class Breadcrumb {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  pages = signal<BreadcrumbItem[]>([]);

  constructor() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => this.pages.set(this.createBreadcrumbs(this.route.root)));
  }

  private createBreadcrumbs(
    route: ActivatedRoute,
    url: string = "",
    breadcrumbs: BreadcrumbItem[] = []
  ): BreadcrumbItem[] {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    const child = children[0];
    const routeURL: string = child.snapshot.url
      .map((segment) => segment.path)
      .join("/");

    if (routeURL !== "") {
      url += `/${routeURL}`;
    }

    const breadcrumb = child.snapshot.data["breadcrumb"];

    if (typeof breadcrumb === "string" && breadcrumb.length) {
      breadcrumbs.push({ label: breadcrumb, url });
    }

    return this.createBreadcrumbs(child, url, breadcrumbs);
  }
}
